module.exports = __webpack_public_path__ + "img/logo.372e717b.png";